<template>
  <v-row dense>
    <v-col cols="12" md="12">
      <autocomplete
        :items="brojDanaBezMenija"
        item-value="val"
        v-model="settings.guest.dani_bez_menija"
        :label="$t('max_days_to_order_daily_menu')"
      />
    </v-col>
    <v-col cols="12" md="12">
      <text-field
        :label="$t('cancel_time')"
        type="number"
        hide-details
        :suffix="$t('minutes')"
        v-model="settings.guest.guest_cancel_order_time"
      />
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "GuestOrderLimitsSection",
  props: {
    settings: {
      type: Object,
      required: true,
    },
    brojDanaBezMenija: {
      type: Array,
      required: true,
    },
  },
};
</script>
